import LegalMentionModal from "@components/Financing/LegalMentionModal";
import { useSCFPriceBreakdownSelector } from "@redux/reducers/deal";
import React, { useMemo, useState } from "react";
import { useTranslation } from "@lib/i18n";
import { bool } from "prop-types";
import Typography from "@components/shared/Typography";

const SCFPriceDetail = ({ isFinanceRequestError }) => {
  const scfBreakdown = useSCFPriceBreakdownSelector();
  const { t } = useTranslation();
  const [isLegalMentionVisible, setIsLegalMentionVisible] = useState(false);

  const legalMention =
    scfBreakdown?.vehicleSimulation?.result?.globalText?.legalMention;

  const data = useMemo(() => {
    if (!scfBreakdown?.vehicleSimulation?.result) {
      return null;
    }

    const {
      displayBlocks,
      globalText: { financialProductLabel },
    } = scfBreakdown.vehicleSimulation.result;
    const lines = displayBlocks[0].displayLines;

    return [
      // column 1
      [
        t("price.scf.monthly", { amount: lines[0].displayValue }),
        lines[1].displayValue,
        t("price.scf.taeg", { amount: lines[2].displayValue }),
      ],
      // column 2
      [
        t("price.scf.initialPayment", { amount: lines[5].displayValue }),
        t("price.scf.financedAmount", { amount: lines[6].displayValue }),
        <>
          {financialProductLabel.text}{" "}
          <button
            className="size-4 p-0 rounded-full bg-white text-primaryDark text-sm/1 italic font-serif cursor-pointer hover:bg-primaryOrange hover:text-white"
            onClick={() => setIsLegalMentionVisible(true)}
            type="button"
          >
            i
          </button>
        </>,
        t("price.deliveryInfo.priceDetail"),
      ],
    ];
  }, [scfBreakdown]);

  if (isFinanceRequestError || !data || !legalMention) {
    return (
      <Typography className="text-white text-lg text-center font-semibold m-auto max-w-80 px-4 text-balance">
        {t("financeDataErrorMessage")}
      </Typography>
    );
  }

  return (
    <div className="flex gap-4 columns-2 text-white text-xxs/[1rem] font-semibold uppercase ml-auto">
      <div className="flex flex-col justify-center gap-1.5">
        {data[0].map((item, idx) => (
          <div className="sm:whitespace-nowrap" key={idx}>
            {item}
          </div>
        ))}
      </div>
      <div className="flex flex-col justify-center gap-1.5">
        {data[1].map((item, idx) => (
          <div className="sm:whitespace-nowrap" key={idx}>
            {item}
          </div>
        ))}
      </div>
      <LegalMentionModal
        isOpen={isLegalMentionVisible}
        legalMention={legalMention}
        onClose={() => setIsLegalMentionVisible(false)}
      />
    </div>
  );
};

SCFPriceDetail.propTypes = {
  isFinanceRequestError: bool,
};

export default SCFPriceDetail;
